export default {
	showStudentVerificationError: false
};
